<template>
  <div>
    <v-btn class="ma-2 caption" color="#E8175D" @click="dialog= !dialog">Login</v-btn>
    <!-- Dialog Login -->
    <v-dialog v-model="dialog" max-width="400" persistent>
      <v-card class="mx-auto" max-width="1000">
        <v-row no-gutters width="100%" style="background: #E8175D" align="center" justify="center">
          <v-col align-center>
            <v-img
              :src="imagenes[0]"
              class="mx-auto"
              max-width="200"
              max-height="200"
              style="background: #E8175D"
            ></v-img>
          </v-col>
        </v-row>

        <v-card-title
          class="title font-weight-regular justify-space-between"
          style="background: #E8175D"
        >
          <span class="white--text">{{ currentTitle }}</span>
          <v-avatar
            color="white"
            class="caption font-weight-black"
            style="color: #E8175D"
            size="18"
            v-text="step"
          ></v-avatar>
        </v-card-title>

        <!-- Paso 1 : ingreso de mail -->
        <v-window v-model="step">
          <v-window-item :value="1">
            <v-card-text>
              <v-text-field label="Email"></v-text-field>
              <span
                class="caption grey--text text--darken-1"
                v-text="$t('login[0]')"
              ></span>
            </v-card-text>
          </v-window-item>
          <!-- Fin Paso 1 : ingreso de mail -->
          <!-- Paso 2 : Ingreso password -->
          <v-window-item :value="2">
            <v-card-text>
              <!-- <v-text-field label="Email"></v-text-field> -->
              <p class="caption red--text">El correo ingresado no existe en los registros</p>
              <!-- <span
                class="caption grey--text text--darken-1"
                v-text="$t('login[0]')"
              ></span> -->
            </v-card-text>
          </v-window-item>
          <!-- <v-window-item :value="2">
            <v-card-text>
              <v-text-field label="Password" type="password"></v-text-field>
              <span class="caption grey--text text--darken-1" v-text="$t('login[1]')"></span>
            </v-card-text>
          </v-window-item> -->
          <!-- Fin Paso 2: Ingreso password-->
          <!-- Paso 3 : Entrando al sistema -->
          <v-window-item :value="3">
            <div class="pa-4 text-center">
              <v-img
                class="mb-4"
                contain
                height="128"
                :src="cargando"
              ></v-img>
              <h3 class="title font-weight-light mb-2" v-text="$t('login[2]')"></h3>
              <span class="caption grey--text" v-text="$t('login[3]')"></span>
            </div>
          </v-window-item>
          <!-- Fin Paso 3 : Entrando al sistema -->
        </v-window>
        <v-divider></v-divider>
        <!-- Botones -->
        <v-card-actions>
          <v-btn :disabled="step === 3" color="white caption" @click="dialog = false" v-text="$t('login[4]')"></v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="step === 1" text @click="step--" class="caption" v-text="$t('login[5]')"></v-btn>
          <v-btn :disabled="step === 2" depressed text @click="step++" class="caption" v-text="$t('login[6]')"></v-btn>
          <!-- <v-btn :disabled="step === 1 || step === 3" text @click="step--" class="caption" v-text="$t('login[5]')"></v-btn>
          <v-btn :disabled="step === 3" v-if="step === 1 || step === 2" class="caption white--text" color="#E8175D" depressed @click="step++" v-text="$t('login[6]')"></v-btn>
          <v-btn :disabled="step === 3" v-else="" class="caption" color="primary" depressed @click="step++" v-text="$t('login[7]')"></v-btn> -->
        </v-card-actions>
        <!-- Fin Botones -->
      </v-card>
    </v-dialog>
    <!-- Fin Dialog Login -->
  </div>
</template>

<script>

export default {
  data() {
    return {
      dialog: false,
      step: 1,
      imagenes: [
        {
          src: require("../assets/LogoEvascopes.png")
        }
      ],
      cargando: require("../assets/cargando.svg")
    };
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Login";
        case 2:
          return "Password";
        default:
          return "";
      }
    }
  }
};
</script>